import { BaseComponent } from '@components/base.component';
import { Component, Input } from '@angular/core';
import { PremiumTimelinePeriod } from '@interfaces/match-data.interface';

@Component({
    selector: 'app-premium-timelines',
    templateUrl: './premium-timelines.component.html',
    styleUrls: ['./premium-timelines.component.scss'],
})
export class PremiumTimelinesComponent extends BaseComponent {

    @Input()
    public sportName: string;

    @Input()
    public data: PremiumTimelinePeriod[] | null = null;

}
